import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class DocumentsAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      name: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.add = this.add.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }
  componentDidMount () {
    this.refs.request_api.header();
  }

  add(event) {
    event.preventDefault();
    var datasave = {
      name: this.state.name,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/documento', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/documento/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Documentos.AdicionarDocumentos.titulo}</h3>
      <Link to="/documentos" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Documentos.AdicionarDocumentos.forumlario.Nome}:</label>
              <input type="text" name="name" className="form-control" placeholder={this.locale.Documentos.AdicionarDocumentos.forumlario.placeholder.NomeDoDocumento} value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
            </div>
          </div>
          <div className="col-md-6">
            <button type="submit" className="btn btn-primary btn-inline btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Documentos.AdicionarDocumentos.forumlario.botaoAdicionarDocumento}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default DocumentsAdd;



// WEBPACK FOOTER //
// ./src/Components/Documents/DocumentsAdd.js